var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter",class:{ 'over-limit': _vm.overLimit },domProps:{"innerHTML":_vm._s(
    _vm.lang.get('miscellaneous.counters.' + _vm.type, {
      used: _vm.counter,
      total: _vm.maximum
    })
  )}})}
var staticRenderFns = []

export { render, staticRenderFns }